import React from "react";

import { useIntl } from "react-intl";
import { useParams } from "react-router-dom";

import { Deployments } from "src/organization/pages/project/environment/metrics/components/timeframeControl/style";
import TimeframeControl from "src/organization/pages/project/environment/metrics/components/timeframeControl/TimeframeControl";
import usePinnedTabsSync from "src/organization/pages/project/environment/metrics/hooks/usePinnedTabsSync";
import ProfilingWrapper, {
  ProfilerInjectProps
} from "src/organization/pages/project/environment/metrics/profiling/widget/ProfilingWrapper";

import * as S from "./style";

const Profiling = (props: unknown) => {
  const { timeframe, setTimeframe, poll, lastUpdated, deploymentProps } =
    props as ProfilerInjectProps;

  const { onSyncChange, isSynced, canJoinSync } = usePinnedTabsSync({
    timeFrame: timeframe,
    setTimeFrame: setTimeframe
  });

  const handleSyncChange = (isSynced: boolean) => {
    onSyncChange(isSynced, timeframe);
  };
  const intl = useIntl();

  return (
    <S.Header>
      <Deployments
        label={intl.formatMessage({ id: "show_deployments" })}
        checked={deploymentProps.enabled}
        onChange={() => {
          deploymentProps.onChange(!deploymentProps.enabled);
        }}
      />

      <TimeframeControl
        timeframe={{
          timeframe,
          onChange: setTimeframe
        }}
        pollInterval={poll}
        lastUpdated={lastUpdated}
        tabSync={{
          onSyncChange: handleSyncChange,
          isSynced,
          canJoinSync
        }}
      />
    </S.Header>
  );
};

const View = () => {
  const { appName = "" } = useParams<{ appName: string }>();

  return (
    <ProfilingWrapper app={{ name: appName }}>
      <Profiling />
    </ProfilingWrapper>
  );
};

export default View;
